import { takeLatest } from "redux-saga/effects";
import { startPropertySubscription } from "./propertiesSlice";
import { handleSubscriptionTask } from "./propertySubscriptionSaga";

export function* propertiesSaga() {
  // Start subscription when requested
  yield takeLatest(startPropertySubscription.type, handleSubscriptionTask);
}
